import ModalGenerateCertificationsModule from './containers/modalGenerateCertificationsModule'

export {default as ModalGenerateCertificationsModuleLayout} from './components/modalGenerateCertificationsModuleLayout'

export default ModalGenerateCertificationsModule
